export interface IParams {
    [key: string]: string | number;
}
export const snitchCounter = (eventName: string, params?: IParams | undefined): void => {
    if (typeof window !== 'undefined' && typeof window.snitch === 'function') {
        window.snitch(eventName, params);
    }
};
